/**
 * CLI-001 — Badge de statut (PROSPECT / CLIENT / ANONYMIZED).
 */

import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import type { ClientStatus } from '@/hooks/useClients.types'

interface Props {
    status: ClientStatus
    className?: string
}

const VARIANT_BY_STATUS: Record<ClientStatus, 'default' | 'secondary' | 'outline' | 'destructive'> = {
    PROSPECT: 'secondary',
    CLIENT: 'default',
    ANONYMIZED: 'outline',
}

export function ClientStatusBadge({ status, className }: Props) {
    const { t } = useTranslation()
    return (
        <Badge variant={VARIANT_BY_STATUS[status]} className={className}>
            {t(`crm.clients.status.${status}`)}
        </Badge>
    )
}
